import React, { useEffect , useCallback , useState , useRef } from 'react';
import { useParams } from "react-router-dom";

import { useGlobalContext } from '../../context/GlobalContext';

import { useForm } from "react-hook-form";
import { API_URL } from '../../../actions';
import { clearMarkup } from '../../../utils/utils';

import BlocText from '../../partials/BlocText';
import SelectMedia from '../medias/SelectMedia'; 
import PromptRouter from '../../partials/PromptRouter';
import RemoveModale from '../../partials/RemoveModale/RemoveModale';

import { getMediasAction } from '../../../actions/mediasActions';
import { getCompanyAction } from '../../../actions/companiesActions';
import { getPageAction , updatePageAction } from '../../../actions/themeActions';



import '../../../styles/pages-sites.scss';
import MetaSeo from '../../partials/MetaSeo';

export default function Quality({ setDisplayNavBar, setDisplaySelectLang , setDisplaySiteNav ,  setActivePage , theme , lang }) {

  const param = useParams();

  const page = 'qualityAndSecurity';

  const { handleSubmit, register, errors } = useForm();

  const [ context, dispatch ] = useGlobalContext();

  // const [ qualityAndSecurity , setQualityAndSecurity ] = useState();
  const [ isUpdated , setIsUpdated ] = useState(false);

  const qualityRef = useRef();
  const qualityAndSecurity = qualityRef.current;

  const [ isMounted , setIsMounted ] = useState(false);
  const [ isSaved , setIsSaved ] = useState(false);
  const [ removeAction , setRemoveAction ] = useState();

  const [ displaySelectMedia , setDisplaySelectMedia ] = useState(false);
  const [ selectedMediaList , setSelectedMediaList ] = useState([]);
  const [ mediaIsMulti , setMediaIsMulti ] = useState(false);
  const [ mediaType , setMediaType ] = useState();
  const [ mediaKey , setMediaKey ] = useState('picture');
  const [ publishIsLoading , setPublishIsLoading ] = useState(false);

  const getCompany = useCallback(() => {
    getCompanyAction(dispatch , param.companyId );
    getMediasAction(dispatch, param.companyId);
  },[dispatch , param.companyId ]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySelectLang(true);
    setDisplaySiteNav(true)
    setActivePage("qualityAndSecurity");
    getCompany();
    return () => {
      setDisplaySelectLang(false);
      qualityRef.current = null ;
      setIsMounted(false)
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getPageAction(dispatch , param.companyId , page , lang );
    qualityRef.current = null ;
    setIsMounted(false);
    dispatch({
      type:'RESET_PAGE',
    });
    // eslint-disable-next-line
  },[lang]);

  useEffect(() => {
    if (context.theme.page) {
      qualityRef.current = {...context.theme.page };
      setIsMounted(true);
    } else {
      qualityRef.current = null ;
      setIsMounted(false);
    };

    dispatch({
      type:'MESSAGE_PAGE',
      payload: null
    });
    // eslint-disable-next-line
  }, [context.theme.page]);

  useEffect(() => {
    if (JSON.stringify(qualityAndSecurity) === JSON.stringify(context.theme.page)) {
      setIsSaved(true);
    } else {
      setIsSaved(false);
    }
    // eslint-disable-next-line
  },[qualityAndSecurity , context.theme.page])

  

  useEffect(() => {
    if (context.theme && context.theme.message === 'Theme successfully updated' ) {

      setPublishIsLoading(false);

      dispatch({
        type:'MESSAGE_PAGE',
        payload: null
      });

      dispatch({
        type: 'SET_TOAST',
        payload: {
          message: "La page a bien été enregistré",
          type: "success"
        }
      });

    };

    // eslint-disable-next-line
  },[context.theme.message]);

  function submitMedia(value) {
    switch (mediaKey) {
      
      case "cover":
        handleChange(value[0] , 'cover');
        break;
    
      default:
        break;
    }
  };

  function handleChange( value , obj) {
    var data = Object.assign({} , qualityRef.current );
    if (data[obj]) {
      data[obj] = value
    }
    qualityRef.current = data
    setIsUpdated(!isUpdated);
  };

  function handleChangeBloc(val , i) {
    var blocs = [...qualityAndSecurity.blocs];
    blocs[i] = val;
    handleChange(blocs , 'blocs');
  }

  function addBloc() {
    var addBlocs = [...qualityAndSecurity.blocs];
    addBlocs.push({ title: "" , text: "" });
    handleChange(addBlocs , 'blocs');
  }

  function deleteBloc(bloc) {
    var deleteBloc = [...qualityAndSecurity.blocs];
    handleChange( deleteBloc.filter(item => item !== bloc) , 'blocs');
  }

  function openSelectCover() {
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('cover');
    setMediaType('image');
    if (qualityAndSecurity && qualityAndSecurity.cover) {
      var pictureArray = [];
      pictureArray.push(qualityAndSecurity.cover);
      setSelectedMediaList(pictureArray)
    }
  }

  const submitqualityAndSecurity = (values)  => {
    var qualityAndSecurityData = {...values, ...qualityAndSecurity};
    var obj = {};
    for (const [key, value] of Object.entries(qualityAndSecurityData)) {
        obj[`${page}.${key}`] = value;
    }

    setPublishIsLoading(true);

    updatePageAction(dispatch , context.companies.company.theme[lang] , 'subsidiary' , page , obj  );

    
    dispatch({
      type:'ERROR_PAGE',
      payload: null
    });
    dispatch({
      type:'MESSAGE_PAGE',
      payload: null
    });
  };

  function renderCoverImg() {
    var imgFound;
    if(qualityAndSecurity && qualityAndSecurity.cover && context.medias.mediasList) {
      imgFound = context.medias.mediasList.find(item => item._id === qualityAndSecurity.cover )
      if (imgFound) {
        return <img src={API_URL + '/' + imgFound.path} alt="qualityAndSecurity" />
      } else if (qualityAndSecurity.cover && qualityAndSecurity.cover.path) {
        return <img src={API_URL + '/' + qualityAndSecurity.cover.path} alt="qualityAndSecurity" />
      }
    }
  }

  function renderEdit() {
    return (
      <div className="list-item transition edit-row">
        <form onSubmit={handleSubmit(submitqualityAndSecurity)} autoComplete="nope">
      
            <div className="form-row">
              <div className="col-1">
                
                <div className="title">
                  <h1 dangerouslySetInnerHTML={{ __html: qualityAndSecurity && qualityAndSecurity.title ? clearMarkup(qualityAndSecurity.title) : "" }} ></h1>
                </div>

                <label htmlFor="title">Titre</label>
                <input
                  name="title"
                  onChange={(e) => handleChange(e.target.value , 'title')}
                  defaultValue={qualityAndSecurity && qualityAndSecurity && qualityAndSecurity.title ? qualityAndSecurity.title  : undefined }
                  ref={register({
                    required: "Compléter le titre",
                  })}
                />
                <p className="error">{errors && errors.title && errors.title.message}</p>

                <div>
                  <input id="titleIsWhite"
                  onChange={(e) => handleChange(!e.target.checked , 'titleIsWhite')}
                    type="checkbox" className="switch" defaultChecked={!qualityAndSecurity.titleIsWhite}
                    />
                  <label htmlFor="titleIsWhite">{qualityAndSecurity.titleIsWhite ? <span>Titre en blanc</span> : <span>Titre en noir</span> }</label>
                </div>

                <div className="section"></div>

                <div className="title">
                  <h2>Les paragraphes</h2>
                </div>

                {qualityAndSecurity && qualityAndSecurity.blocs && qualityAndSecurity.blocs.map((bloc , i ) => (<BlocText
                  key={'blocktext' + i }
                  setBlockText={(val) => handleChangeBloc(val , i)}
                  deleteBloc={deleteBloc}
                  setRemoveAction={setRemoveAction}
                  blockText={bloc}
                  index={i} />
                ))}

                <div className="btn-container" >
                  <button
                    className={`btn primary ${theme}-bg`}
                    style={{ marginBottom: 20}}
                    onClick={() => addBloc() }
                    type="button"
                    >
                    Ajouter un paragraphe
                  </button>
                </div>
                
              </div>

              <div className="col-2">
                <div className="btn-actions-container" >
                  {publishIsLoading ?
                    null
                    :
                    <button
                      className={`btn primary publish ${theme}-bg`}
                      type="submit"
                      >
                      Publier
                    </button>
                  }
                </div>

                <label>Photo de couverture <span className={`${theme}-color required`}>*</span><br/><span className="note">minimum 1700 x 350 px</span></label>
                {renderCoverImg()}
                <div className="btn-container">
                  
                  <button
                    type="button"
                    className={`btn primary ${theme}-bg`}
                    onClick={() => openSelectCover(true)}
                    >
                    Parcourir
                  </button>

                  {qualityAndSecurity && qualityAndSecurity.cover &&
                    <button
                      type="button" 
                      className={`btn primary ${theme}-bg`}
                      onClick={() => setRemoveAction( {function:() => handleChange( null , 'cover') } )}
                      >
                      Supprimer
                    </button>
                  }
                </div>

              </div>
            </div>

            <MetaSeo
              seo={qualityAndSecurity?.seo}
              onChange={(seoData) => {
                qualityRef.current = { ...qualityRef.current, seo: seoData };
                setIsUpdated(!isUpdated);
              }}
              theme={theme}
              companyId={param.companyId}
            />
            
        </form>
        <SelectMedia
          displaySelectMedia={displaySelectMedia}
          dispatch={dispatch}
          theme={theme}
          context={context}
          mediaType={mediaType}
          selectedMediaList={selectedMediaList}
          companyId={param.companyId}
          isMulti={mediaIsMulti}
          handleChange={(value) => submitMedia(value)}
          setDisplaySelectMedia={setDisplaySelectMedia}
        />
      </div>
    )
  }

  return (
    <>
      <PromptRouter when={!isSaved} />
      {isMounted && qualityAndSecurity && <div id="innovation" className={`page-container site ${theme}`}>
        <div className="page-content">

          <div className="title-row space-between">

            <div className="flex">

              <div className="title">
                <h1>Edition de la page qualité et sécurité ({lang})</h1>
                <div className="bar primary"></div>
              </div>

            </div>

          </div>

          <div className="list-container">
            {renderEdit()}
          </div>

        </div>
      </div>}
      <RemoveModale removeAction={removeAction} setRemoveAction={setRemoveAction} theme={theme}/>
    </>

  )
}
